import React from 'react';
import { Box } from '@mui/material';
import { useRecoilValue } from 'recoil';

import { currentCameraLayoutState } from './../../common/recoil/Cameras/atom';
import HighlightedCameras from './components/HighlightedCameras';

const CameraLayout = ({ localMedia }) => {
	const currentCameraLayout = useRecoilValue(currentCameraLayoutState);

	return (
		<Box>
			<HighlightedCameras localMedia={localMedia} />
		</Box>
	);
};

export default CameraLayout;
